/* Exor Games — card condition dropdowns.
   Grays out sold-out conditions in the visible card dropdown. Theme-rendered
   cards already ship those options disabled from Liquid; this pass covers
   card markup the theme does not render — the search app clones the original
   card HTML with every variant listed and no availability marks.
   Availability is read from the hidden add-to-cart selects in the same card
   (.product-form__variants options carry data-available / disabled). The
   visible select is never removed, replaced, or re-ordered and options are
   only ever disabled in place — theme JS resolves variants by id, so both
   are safe (see NOTES.md recon). Fails silently when a card has no data. */
(function () {
  'use strict';

  function availability(card) {
    var opts = card.querySelectorAll('select.product-form__variants option');
    var map = null;
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var id = o.getAttribute('value');
      if (!id) continue;
      var avail = !(o.disabled || o.getAttribute('data-available') === '0');
      if (!map) map = {};
      /* a variant appears in two hidden selects — available if either says so */
      map[id] = map[id] === true ? true : avail;
    }
    return map;
  }

  function enhance(sel) {
    if (sel.getAttribute('data-xg-oos') === '1' || !sel.closest) return;
    var card = sel.closest('.grid-view-item');
    if (!card) return;
    var map = availability(card);
    if (!map) return; /* no data yet — a later scan retries */
    sel.setAttribute('data-xg-oos', '1');
    var mapped = 0;
    var anyAvailable = false;
    for (var i = 0; i < sel.options.length; i++) {
      var opt = sel.options[i];
      var id = opt.getAttribute('value');
      if (!id || !(id in map)) continue;
      mapped++;
      if (map[id]) {
        anyAvailable = true;
        continue;
      }
      if (!opt.disabled) {
        opt.disabled = true;
        if (opt.text.toLowerCase().indexOf('sold out') === -1) {
          opt.text = opt.text.replace(/\s+$/, '') + ' - Sold Out';
        }
      }
    }
    if (mapped > 0 && !anyAvailable) sel.disabled = true; /* whole card OOS → gray pill */
  }

  function scan(root) {
    var sels = (root || document).querySelectorAll('select[data-dropdown-id="productSelect-dropdown"]');
    for (var i = 0; i < sels.length; i++) enhance(sels[i]);
  }

  function start() {
    scan();
    if (!window.MutationObserver || !document.body) return;
    var timer = null;
    /* search app re-renders results on every filter/sort — re-scan, debounced */
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        scan();
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
